import { fetchJSON } from "./fetchJSON";
import { baseUrl } from "./baseUrl";
import { FORMAT_ISO, formatSafe } from "utils/toDate";
import type {
  Conducteur,
  Vehicule,
  Contrat,
  ReveleInformations,
  Sinistre,
} from "model/releveInformation";
import type { ReleveQuery } from "pages/MesReleves/MesReleves";
import { SelectionDemandeResultApi } from "pages/RechercheRIHorsParc/models/selectionDemandeResult";

export type RelevesHorsParcWithLogos = {
  releveInformations: Map<string, ReleveHorsParc[]>;
};

export type ReleveHorsParc = {
  refPlatforme: string;
  souscripteur: string;
  dateNaissanceSouscripteur: string;
  raisonSociale: string;
  siret: string;
  siren: string;
  nic: string;
  numeroPolice: string;
  numeroPoliceIntermediaire: string;
  assureur: string;
  codeAssureur: string;
  intermediaire: string;
  codeIntermediaire : string;
  crm: string;
  dateMaj: string;
  statut: string;
  dateDebut: string;
  dateFin: string;
  codeGestionnaireGlobal: string;
  codeGestionnaireSinistre: string;
  nomGestionnaireGlobal: string;
  nomGestionnaireSinistre: string;
  numeroImmatriculation: string;
  numeroPermisSouscripteur?: string;
  datePermisSouscripteur?: string;
  permisEtrangerSouscripteur?: boolean;
  conducteurs: Conducteur[];
  sinistres: Sinistre[];
  vehicules: Vehicule[];
  codePortefeuille: string;
  libellePortefeuille: string;
  portefeuilleId: number;
  adresse1: string;
  adresse2?: string;
  adresse3?: string;
  codePostal: string;
  ville: string;
  cedex?: string;
  pays: string;
  telephone?: string;
  mail?: string;
  lieuNaissanceSouscripteur?: string;
  nomNaissanceSouscripteur?: string;
};

// export type ReleveInformationsHorsParc = {
//   [key: string]: ReleveHorsParc;
// };

export type API_LIST<T> = {
  totalItems: number;
  relevesInformations: T[];
  totalPages: number;
  currentPage: number;
};

export type Releve = {
  refPlatforme: string;
  souscripteur: string;
  dateDebut: string;
  dateFin: string;
  dateInformation: string;
  dateMaj: string;
  crm: string;
  dateNaissance: string;
  nom: string;
  nomSociete: string;
  codeSociete: string;
  numeroImmatriculations: string[];
  numeroPolice: string;
  numeroPoliceIntermediaire: string
  statut: string;
  nomGestionnaireGlobal: string;
  codeGestionnaireGlobal: string;
  nomGestionnaireSinistre: string;
  codeGestionnaireSinistre: string;
  raisonSociale: string;
  siren: string;
  codeNIC: string;
  nbConducteurs: number;
  nbSinistres: number;
  incomplet: boolean;
  codePortefeuille: string;
  libellePortefeuille: string;
};

export type ReleveApi = API_LIST<Releve>;

export async function findMyReleves(query: ReleveQuery) {
  const url = new URL("/backend/v1/releves-informations", baseUrl);
  for (let [key, value] of Object.entries(query)) {
    if (key === "dateDebut" || key === "dateFin") {
      if (value) url.searchParams.set(key, String(formatSafe(value as Date, FORMAT_ISO)));
    } else {
      if (value) url.searchParams.set(key, String(value));
    }
  }
  return fetchJSON<ReleveApi>(url);
}

export function createReleve(releve: ReveleInformations) {
  return fetchJSON<{ id: string; error: undefined } | { error: string; id: undefined }>(
    new URL("/backend/v1/releves-informations", baseUrl),
    { method: "POST", data: releve }
  );
}

export async function findRelevesHorsParcByParticulier(query: any) {
  const url = new URL("/backend/v1/releves-informations/hors-parc/particulier", baseUrl);
  for (let [key, value] of Object.entries(query)) {
    if (key === "dateNaissance") {
      if (value) url.searchParams.set(key, String(formatSafe(value as Date, FORMAT_ISO)));
    } else if (value != null && value !== "") url.searchParams.set(key, String(value));
  }
  return fetchJSON<SelectionDemandeResultApi>(url);
}

export async function findRelevesHorsParcBySociete(query: any) {
  const url = new URL("/backend/v1/releves-informations/hors-parc/societe", baseUrl);
  for (let [key, value] of Object.entries(query)) {
    if (value != null && value !== "") url.searchParams.set(key, String(value));
  }
  return fetchJSON<SelectionDemandeResultApi>(url);
}

export async function validateContrat(contrat: Contrat) {
  const url = new URL("/backend/v1/releves-informations/check-contrat", baseUrl);
  return fetchJSON<{ check: boolean }>(url, { method: "POST", data: { contrat } });
}

export async function validateVehicule(vehicule: Vehicule) {
  const url = new URL("/backend/v1/releves-informations/check-vehicule", baseUrl);
  return fetchJSON(url, { method: "POST", data: vehicule });
}
export async function validateConducteur(conducteur: Conducteur) {
  const url = new URL("/backend/v1/releves-informations/check-conducteur", baseUrl);
  return fetchJSON(url, { method: "POST", data: conducteur });
}
export async function findInfoFvaByImmatriculation(immatriculation: string) {
  const url = new URL("/backend/v1/infos-siv", baseUrl);
  url.searchParams.set("immatriculation", immatriculation);
  // return {
  //   numeroImmatriculation: immatriculation,
  //   vin: "KL1SF48WJ9W035343",
  //   marque: "Toyota",
  //   modele: "Yaris",
  // };
  return fetchJSON(url);
}
